import axios from "axios";

export abstract class BaseApi {
  protected client = axios.create({
    baseURL: `${process.env.REACT_APP_API_ROOT}/v2/web`,
  });
}
